/**
 * The public SOA form's wording and input rules (SoaFormPage). Pure, so the
 * tests can hold them to what the page has always done.
 */

/** Chinese when the form says so, or when it says "auto" and the browser is Chinese. */
export function prefersChinese(config, language = typeof navigator !== "undefined" ? navigator.language : "") {
  if (!config) return false;
  if (config.language === "zh") return true;
  if (config.language === "en") return false;
  return (language || "").toLowerCase().startsWith("zh");
}

/**
 * One language when the form names one, both (split by "  |  ") only for
 * "auto", which has nothing to go on but the browser and would otherwise
 * hide half the form from someone who cannot read the other half.
 */
export function bilingual(config, en, zhText) {
  const choice = config?.language;
  if (choice === "en") return en || zhText || "";
  if (choice === "zh") return zhText || en || "";
  if (!zhText) return en || "";
  if (!en) return zhText;
  return `${en}  |  ${zhText}`;
}

/** MM/DD/YYYY formed as digits are typed. */
export function formatDateInput(value) {
  const digits = (value || "").replace(/[^0-9]/g, "").slice(0, 8);
  if (!digits) return "";
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

/** A prefilled date in any loose shape ("9/5/26") as MM/DD/YYYY. */
export function normalizeUsDate(value) {
  const loose = /^\s*(\d{1,2})\D(\d{1,2})\D(\d{2,4})\s*$/.exec(value || "");
  if (loose) {
    const month = loose[1].padStart(2, "0");
    const day = loose[2].padStart(2, "0");
    const year = loose[3].length === 2 ? `20${loose[3]}` : loose[3];
    return `${month}/${day}/${year}`;
  }
  return formatDateInput(value);
}

/** A real calendar date (02/29 only in a leap year), 2000–2100. */
export function isValidUsDate(value) {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || "");
  if (!match) return false;
  const [month, day, year] = [Number(match[1]), Number(match[2]), Number(match[3])];
  if (month < 1 || month > 12 || day < 1 || year < 2000 || year > 2100) return false;
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

/** (215) 825-8435 formed as digits are typed. */
export function formatUsPhone(value) {
  const digits = (value || "").replace(/[^0-9]/g, "").slice(0, 10);
  if (!digits) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
